import { Outlet } from "react-router-dom";

import { SplashScreens } from "@/components/Layout/SplashScreens/SplashScreens";
import { FullScreenLoadingProvider } from "@/provider/FullScreenLoadingProvider/FullScreenLoadingProvider";

import { SessionExpiredModal } from "./components/SessionExpiredModal";

export const App = () => (
  <FullScreenLoadingProvider>
    <SplashScreens />
    <div className="flex min-h-screen flex-col">
      <div
        data-testid="app"
        className="relative flex h-auto flex-grow flex-col overflow-hidden"
      >
        <Outlet />
      </div>
      <SessionExpiredModal />
    </div>
  </FullScreenLoadingProvider>
);
